import { ThemeUICSSObject } from 'theme-ui';

export const assistant: ThemeUICSSObject = {
  floatingAssistant: {
    '& div.modal__content[class]': {
      p: 3,
      width: 'min(90vw, 500px)',
    },

    '.modal__main': {
      maxWidth: 'unset',
      overflow: 'hidden',
    },
  },
};
